
import axios from 'axios'
import {Message} from 'element-ui'

var instance = axios.create({
  baseURL: process.env.VUE_APP_BASEURLSERVICE,
  //跳转rpo
  baseURL2: process.env.VUE_APP_BASEURLSERVICEELSE,
  //跳转嗖嗖管
  baseURL3: process.env.VUE_APP_BASEURLSERVICEANTHER,
  //跳转嗖嗖发薪
  baseURL4: process.env.VUE_APP_BASEURLSERVICEANTHERS,
  //跳转嗖嗖用工
  baseURL5: process.env.VUE_APP_BASEURLSERVICEEMPLOYMENT,
  baseURL6: process.env.VUE_APP_BASEURLSOUSOUSHEBAOQIANDAO,
  //嗖嗖社保后道
  baseURL7: process.env.VUE_APP_BASEURLSOUSOUSHEBAOHOUDAO,
	// baseURL: 'http:/172.16.93.88:8084/server',
  timeout: 10000,
  withCredentials: true,
  headers: {
    'accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

instance.interceptors.response.use((response)=>{
  return response;
}, (error) => {
  if (error && error.response) {
    const status = error.response.status
    switch (status) {
      case 401:
        Message.error('登录超时，请重新登录')
        // window.location.href = axios.defaults.baseURL+'#/login'
        // window.location.href = 'http://sshr.tmocloud.com/sshrserver/#/login';	
        window.location.href = process.env.VUE_APP_BASEURLSERVICEMAIN + '#/login';		
        break;
      case 403:
        Message.warning('您没有操作该模块的权限，如要继续请联系管理员')
        break;
    }
  }
})

export default instance